export default __webpack_public_path__ + "static/media/doorIcon.78648dfa.svg";